
import Vue from "vue";
import dayjs from "dayjs";
import { marked } from "marked";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import ListContainer from "../components/shared/ListContainer.vue";
import MultiMovies from "../components/shared/MultiMovies.vue";
import { ILive, ISong } from "../@types/interface.d";

interface DataType {
  live?: ILive;
}

interface MethodType {
  init: () => void;
  twitterLink: () => string
}

interface ComputedType {
  convertedMemo: string;
}

export default Vue.extend({
  name: "liveDetail",
  components: {
    Headline,
    ListContainer,
    MultiMovies,
    Breadcrumb,
    BreadcrumbItem,
  },
  data(): DataType {
    return {
      live: undefined,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const { key } = this.$route.params;
      const year = key.split("-")[0];
      fetch(`/api/lives/${year}/${key}`).then(res => res.json()).then((data: ILive) => {
        this.live = data;
      });
    },
    twitterLink(tab: string) {
      if (!this.live) {
        return "";
      }
      const d = dayjs(this.live.date);
      const since = d.format("YYYY-MM-DD");
      const until = d.add(2, "day").format("YYYY-MM-DD");
      return `https://twitter.com/search?q=(%23%E3%81%84%E3%81%8E%E3%81%AA%E3%82%8A%E6%9D%B1%E5%8C%97%E7%94%A3)%20until%3A${until}%20since%3A${since}%20min_faves%3A10&src=typed_query&f=${tab}`;
    },
    songName(song: ISong): string {
      return song.alias || song.name;
    },
  },
  computed: {
    convertedMemo(): string {
      if (!this.live?.memo) {
        return "";
      }
      return marked(this.live.memo);
    },
    movies(): string[] {
      if (!this.live || !this.live.movie) {
        return [];
      }
      return this.live.movie.split(/\r\n|\n/).map(v => v.trim()).filter(v => v.length > 0);
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
